import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createBlock as _createBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  class: "level is-mobile mb-0",
  style: {"overflow-x":"auto"}
}
const _hoisted_2 = { class: "card-content pb-0" }
const _hoisted_3 = {
  key: 0,
  class: "content"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", null, "Für diese Tage ist ein Türchen vorhanden:", -1)
const _hoisted_5 = { class: "tags" }
const _hoisted_6 = {
  key: 2,
  class: "card-content"
}
const _hoisted_7 = { class: "card-footer is-flex is-justify-content-space-around" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BulmaButton = _resolveComponent("BulmaButton")!
  const _component_BulmaBreadcrumbs = _resolveComponent("BulmaBreadcrumbs")!
  const _component_DoorPlacer = _resolveComponent("DoorPlacer")!
  const _component_DoorChooser = _resolveComponent("DoorChooser")!
  const _component_Calendar = _resolveComponent("Calendar")!
  const _component_BulmaDrawer = _resolveComponent("BulmaDrawer")!

  return (_openBlock(), _createBlock(_component_BulmaDrawer, {
    header: "Türchen bearbeiten",
    onOpen: _ctx.on_open
  }, {
    default: _withCtx(() => [
      _createElementVNode("nav", _hoisted_1, [
        _createVNode(_component_BulmaButton, {
          disabled: _ctx.current_step === 0,
          class: "level-item is-link",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.current_step--)),
          icon: "fa-solid fa-backward"
        }, null, 8, ["disabled"]),
        _createVNode(_component_BulmaBreadcrumbs, {
          steps: _ctx.steps,
          modelValue: _ctx.current_step,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.current_step) = $event)),
          class: "level-item mb-0"
        }, null, 8, ["steps", "modelValue"]),
        _createVNode(_component_BulmaButton, {
          disabled: _ctx.current_step === 2,
          class: "level-item is-link",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.current_step++)),
          icon: "fa-solid fa-forward"
        }, null, 8, ["disabled"])
      ]),
      _createElementVNode("div", _hoisted_2, [
        (_ctx.doors.length > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _hoisted_4,
              _createElementVNode("div", _hoisted_5, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.doors.toSorted((a, b) => a.day - b.day), (door, index) => {
                  return (_openBlock(), _createElementBlock("span", {
                    key: `door-${index}`,
                    class: "tag is-primary"
                  }, _toDisplayString(door.day), 1))
                }), 128))
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      (_ctx.current_step === 0)
        ? (_openBlock(), _createBlock(_component_DoorPlacer, {
            key: 0,
            doors: _ctx.doors
          }, null, 8, ["doors"]))
        : _createCommentVNode("", true),
      (_ctx.current_step === 1)
        ? (_openBlock(), _createBlock(_component_DoorChooser, {
            key: 1,
            doors: _ctx.doors
          }, null, 8, ["doors"]))
        : _createCommentVNode("", true),
      (_ctx.current_step === 2)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createVNode(_component_Calendar, { doors: _ctx.doors }, null, 8, ["doors"])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("footer", _hoisted_7, [
        _createVNode(_component_BulmaButton, {
          class: "card-footer-item is-danger",
          onClick: _ctx.on_download,
          icon: "fa-solid fa-cloud-arrow-down",
          busy: _ctx.loading_doors,
          text: "Laden"
        }, null, 8, ["onClick", "busy"]),
        _createVNode(_component_BulmaButton, {
          class: "card-footer-item is-warning",
          onClick: _ctx.on_discard,
          icon: "fa-solid fa-trash",
          text: "Löschen"
        }, null, 8, ["onClick"]),
        _createVNode(_component_BulmaButton, {
          class: "card-footer-item is-success",
          onClick: _ctx.on_upload,
          icon: "fa-solid fa-cloud-arrow-up",
          busy: _ctx.saving_doors,
          text: "Speichern"
        }, null, 8, ["onClick", "busy"])
      ])
    ]),
    _: 1
  }, 8, ["onOpen"]))
}